module.exports = __webpack_public_path__ + "img/logo-f1.ddadf0b7.png";